<template>
  <div class="home">
    <div class="title">
      Danghuan
    </div>
    <div class="success">
      <img src="../../assets/image/upload/2.png" alt="" class="success-logo">
      <span class="successText">已完成</span>
      <div class="goodsNum">物品编码：365987546<span class="goodsNumSix">151254</span></div> 
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'inspectionPhotographSuccess',
  components: {
  },
  data () {
    return {}
  },
  computed: {
    ...mapState({
      isMaxScreen: state => {
        return state.isMaxScreen
      }
    })
  },
  methods: {
  }
}
</script>
<style scoped lang="less">
@media (max-width: 980px) {

  .home{
    background: #F6F6F6;
  }

  .title{
    height: 88px;
    background-color: #fff;
    line-height: 88px;
  }

  .success{
    display: flex;
    flex-direction: column;
    align-items: center;
    .success-logo{
      width: 120px;
      height: 120px;
      margin-top: 160px;
      margin-bottom: 52px;
    }
    .successText{
      color: #333;
      text-align: center;
      font-family: "PingFang SC";
      font-size: 36px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      margin-bottom: 20px;
    }

    .goodsNum{
      color: #666;
      text-align: center;
      font-family: "PingFang SC";
      font-size: 30px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
    .goodsNumSix{
      color: #405FFF;
    }
  }

}
@media (min-width: 981px) {
  .home {
   
  }
}
</style>
